module.exports = __webpack_public_path__ + "static/media/Ardent-IsolatedFranklynAddress.552959d7.jpg";